import logo from "../../images/Logo.png";
import M from "materialize-css";
import { Link } from "react-router-dom";
import React, { useEffect } from "react";

export default function Header() {
  useEffect(() => {
    let elems = document.querySelectorAll(".sidenav");
    M.Sidenav.init(elems);
    let dropdownElems = document.querySelectorAll(".dropdown-trigger");
    M.Dropdown.init(dropdownElems, {
      constrainWidth: false,
      coverTrigger: false,
    });
  }, []);
  return (
    <div>
      <nav className="backgroundColor stick-navbar">
        <div className="nav-wrapper container">
          <ul id="" className="right">
            <li>
              <a href="mailto: j.mutch.ortho@gmail.com">
                <i class="material-icons hide-on-small-only">email</i> &nbsp;&nbsp;&nbsp;
                <span> j.mutch.ortho@gmail.com</span>
              </a>
            </li>
            <li className="hide-on-med-and-down">
              <a href="https://maps.app.goo.gl/cY8mGsgppjoyjDFN7">
                <i class="material-icons">location_on</i> &nbsp;&nbsp;
                <span> Westmount Square</span>
              </a>
            </li>
            <li className="hide-on-med-and-down">
              <a href="https://maps.app.goo.gl/FWnAXDWUk6WKNbfQA">
                <i class="material-icons">location_on</i> &nbsp;&nbsp;
                <span> St-Mary’s hospital </span>
              </a>
            </li>
            <li className="book-appointment hide-on-small-only">
              <div className="col s12">
                <a class="waves-effect waves-light white black-text btn-appointment">               
                  <Link to="/ContactUs" className="black-text">
                  <i class="material-icons left">local_phone</i>  Contact Us
              </Link>
                </a>
              </div>
            </li>
                 <li className="book-appointment book-appointment-mobile hide-on-med-and-up ">
              <div className="col s12">
                <a class="waves-effect waves-light white black-text btn-appointment">               
                  <Link to="/ContactUs" className="black-text">
                   Contact Us
              </Link>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <ul id="dropdown1" class="dropdown-content indigo-text">
        <li>
          <Link to="/HipReplacement" className="indigo-text">
            {" "}
            Hip Replacement
          </Link>
        </li>
        <li>
          <Link to="/KneeReplacement" className="indigo-text">
            Knee Replacement
          </Link>
        </li>
        
        <li>
          <Link to="/ShoulderReplacement" className="indigo-text">
            {" "}
            Shoulder Replacement
          </Link>
        </li>
        <li>
          <Link to="/RoboticAssistedJointReplacement" className="indigo-text">
            Robotic-assisted Joint Replacement
          </Link>
        </li>
      </ul>
      <ul id="dropdown2" class="dropdown-content">
        <li>
          <Link to="/About" className="indigo-text">
            {" "}
            About Dr. Mutch
          </Link>
        </li>
        <li>
          <Link to="/Clinics" className="indigo-text">
            {" "}
            Clinics
          </Link>
        </li>
      </ul>
      <nav className="white non-stick-navbar">
        <div className="nav-wrapper container">
          <a href="#" className="brand-logo">
            <img src={logo} className="logo" />
          </a>
          <a href="#" data-target="mobile-demo" className="sidenav-trigger">
            <i className="material-icons black-text">menu</i>
          </a>
          <ul id="nav-mobile" className="right hide-on-med-and-down">
            <li>
              <Link to="/" className="black-text">
                Home <span className="header-seperator">|</span>
              </Link>
            </li>
            {/* <li>
              <a href="#about" className="black-text">
                About <span className="header-seperator">|</span>
              </a>
            </li> */}
            <li>
              <a
                class="dropdown-trigger black-text"
                href="#!"
                data-target="dropdown2"
              >
                About
                <i class="material-icons right">arrow_drop_down</i>
                {/* <span className="header-seperator">|</span> */}
              </a>
            </li>
            {/* <li>
              <a href="expertise.html" className="black-text">
                Surgeries <span className="header-seperator">|</span>
              </a>
            </li> */}
            <li>
              <a
                class="dropdown-trigger black-text"
                href="#!"
                data-target="dropdown1"
              >
                Surgeries
                <i class="material-icons right">arrow_drop_down</i>
                {/* <span className="header-seperator">|</span> */}
              </a>
            </li>
            <li>
              {/* <a href="#articles" className="black-text">
                Articles <span className="header-seperator">|</span>
              </a> */}
              <Link to="/Article" className="black-text">
                In the news <span className="header-seperator">|</span>
              </Link>
            </li>
            <li>
              <Link to="/ContactUs" className="black-text">
                 Contact Us <span className="header-seperator">|</span>
              </Link>
            </li>
            {/* <li>
              <a href="enfr.html" className="black-text">
                EN | FR{" "}
              </a>
            </li> */}
          </ul>

          <ul className="sidenav" id="mobile-demo">
            <br />
            <li>
              <Link to="/" className="black-text">
                Home
              </Link>
            </li>
            <li className="surgeries-sub-category">
              <Link to="/About"> - About Dr. Mutch</Link>
            </li>
            <li className="surgeries-sub-category">
              <Link to="/Clinics"> - Clinics</Link>
            </li>
            <li>
              <a href="#expertise" className="black-text">
                Surgeries
              </a>
            </li>
            <li className="surgeries-sub-category">
              <Link to="/HipReplacement">- Hip Replacement</Link>
            </li>
            <li className="surgeries-sub-category">
              <Link to="/KneeReplacement">- Knee Replacement</Link>
            </li>
            
            <li className="surgeries-sub-category">
              <Link to="/ShoulderReplacement">- Shoulder Replacement</Link>
            </li>
            <li className="surgeries-sub-category">
              <Link to="/RoboticAssistedJointReplacement">
                - Robotic-assisted Joint Replacement
              </Link>
            </li>
            <li>
              <Link to="/Article" className="black-text">
                Articles
              </Link>
              {/* <a href="#articles" className="black-text">
                Articles
              </a> */}
            </li>
            <li>
              <Link to="/ContactUs" className="black-text">
                 Contact Us
              </Link>
            </li>
            {/* <li>
              <a href="enfr.html" className="black-text">
                EN | FR{" "}
              </a>
            </li> */}
          </ul>
        </div>
      </nav>

      {/* <nav classNameName='navbar'>
            <div classNameName='container'>
            <img src={logo} style={{height:"100px"}} />
            <div classNameName="right-align">

            </div>
            </div>
            </nav> */}
    </div>
  );
}
